// @flow
export const addEventParamsToUrl = (
  url: string,
  gtmEventParameters: Array<{ [string]: string }>
) => {
  let newUrl = url;
  if (gtmEventParameters) {
    for (let i = 0; i < gtmEventParameters.length; i += 1) {
      const params = gtmEventParameters[i];
      let paramsString = '';

      if (params) {
        Object.keys(params).forEach(key => {
          if (Array.isArray(params[key])) {
            const arr = params[key];
            if (arr.length) {
              arr.forEach(val => {
                paramsString += paramsString ? '&' : '';
                paramsString += `${key}[]=${val}`;
              });
            } else {
              paramsString += paramsString ? '&' : '';
              paramsString += `bepEmptyList=${key}`;
            }
          } else {
            paramsString += paramsString ? '&' : '';
            paramsString += `${key}=${params[key]}`;
          }
        });

        if (paramsString) {
          newUrl += `${newUrl.split('?')[1] ? '&' : '?'}bep=${encodeURIComponent(paramsString)}`;
        }
      }
    }
  }

  return newUrl;
};

export default {
  addEventParamsToUrl,
};



// WEBPACK FOOTER //
// ../utilities/url.server.js